import React from "react";
import { useTranslation } from "react-i18next";
import GearHeadings from "../../ui/gearheadings";
import GearButton from "../../ui/gearbutton";
import BookingCalendar from "../BookingCalendar";

interface PalBookingViewProps {
  title: string;
  onBook: (date: Date) => void;
  onBack: () => void;
}

const PalBookingView: React.FC<PalBookingViewProps> = ({
  title,
  onBook,
  onBack,
}) => {
  const { t } = useTranslation();

  return (
    <div className="space-y-6 animate-scale-in">
      <GearHeadings variant="h3" className="text-secondary">
        {title}
      </GearHeadings>
      <div className="bg-white/5 p-6 rounded-2xl border border-white/5">
        <p className="text-sm font-medium text-white/60 mb-4">
          {t("booking.title", "Prenotazione")}
        </p>
        <BookingCalendar onBook={onBook} />
      </div>
      <GearButton variant="ghost" onClick={onBack} className="w-full">
        {t("forms.back", "Indietro")}
      </GearButton>
    </div>
  );
};

export default PalBookingView;
